
<mat-dialog-content class="mat-badge-medium">
  <div mat-dialog-title >Change owner of the selected rebalance(s)</div>
  <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button>
  <label>New Owner:</label>
  @if ( ownerList) {
    <mat-select placeholder="Select">
      @for (item of ownerList.items; track item) {
        <span (click)="onChange(item)">
      <mat-option  [value]="item"  [style]="{'border-bottom': 
      item.groupSeparater?'1px dashed #000':''}">
            {{item.name}}
          </mat-option>
        </span>
      }
    </mat-select>
  }
  <br><br><br>

  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button id="saveButton"   [disabled] = "isDisable" class="btn-medium-primary btnWidth" (click)="changeOwnerSchdReblances()">Save</button>

  </mat-dialog-actions>
</mat-dialog-content>